import { helpers } from '@reveni-io/reveni-ui'

import { splitDescriptionIntoSegments } from '../helpers'
import { descriptionErrorMessages, variableDenotationChar } from './constants'

const mapDescriptionSegmentToOp = segment => {
  if (segment.text) return { insert: segment.text }

  return {
    insert: {
      mention: {
        id: 1,
        value: segment.variable.variable.replace(variableDenotationChar, ''),
        denotationChar: variableDenotationChar,
      },
    },
  }
}

const getDescriptionTextFromOp = op => {
  if (typeof op.insert === 'string') return op.insert

  const { mention } = op.insert

  if (!mention) return ''

  return mention.denotationChar + mention.value
}

export const getEditorContentsFromDescription = description => {
  return {
    ops: [...splitDescriptionIntoSegments(description).map(mapDescriptionSegmentToOp), { insert: '\n' }],
  }
}

export const getDescriptionFromEditorContents = editorContents => {
  const text = editorContents.ops.map(getDescriptionTextFromOp).join('')

  return text.replace(/\n$/, '')
}

export const getEditorHtml = editor => helpers.replaceNonBreakingSpaces(editor.getSemanticHTML())

export const getDescriptionErrorMessage = errors => {
  const descriptionError = errors.find(error => descriptionErrorMessages[error.type])

  return descriptionErrorMessages[descriptionError?.type]
}
